export default __webpack_public_path__ + "static/Moquette-c694f6558297bfa09bb5a40121ad95f1.jpg";